import { BrandOverlayEntity } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandOverlayCreateResponseDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandOverlayCreateResponseDTO.validationSchema(),
    BrandOverlayEntity
  );

  constructor(readonly data: RoomBrandOverlayCreateResponse) {
    JsonSchemaValidator.assert(
      RoomBrandOverlayCreateResponseDTO.validation,
      data
    );
  }

  toJSON() {
    return this.data;
  }

  // eslint-disable-next-line @typescript-eslint/member-ordering
  private static validationSchema() {
    return {
      type: "object",
      required: ["brandOverlay"],
      properties: {
        brandOverlay: {
          instanceof: BrandOverlayEntity.name
        }
      },
      additionalProperties: false
    };
  }
}

interface RoomBrandOverlayCreateResponse {
  brandOverlay: BrandOverlayEntity;
}
